import { Circle } from '@mui/icons-material';
import { Box, Link, Typography, useMediaQuery, useTheme } from '@mui/material';
import { FormSection } from 'components/form';
import styles from './Led.module.scss';
import { useEffect } from 'react';
import { useFormState } from 'hooks/useFormState';
export function CreateDeviceModalLedSection() {
    const theme = useTheme();
    const isTabletOrMobile = useMediaQuery(theme.breakpoints.down('lg'));

    const formSectionTitle = 'Led';

    const { setIsFormSubmitDisabled, currentFormSectionIndex, formSections } =
        useFormState();

    useEffect(() => {
        if (
            currentFormSectionIndex === formSections.indexOf(formSectionTitle)
        ) {
            setIsFormSubmitDisabled(false);
        }
    }, [setIsFormSubmitDisabled, currentFormSectionIndex, formSections]);

    return (
        <FormSection title={formSectionTitle}>
            <Typography variant="h5">
                Confirm the LEDs on your monitor
            </Typography>
            <Box
                className={`${styles.leds} ${
                    isTabletOrMobile ? styles.ledsTablet : ''
                }`}
            >
                {possibleLedSequences.map(({ title, sequence }) => (
                    <Box key={title} className={styles.ledContent}>
                        <Typography variant="h6" textAlign={'center'}>
                            {title}
                        </Typography>
                        <Box className={styles.led}>
                            {sequence.map((sequence: any, index) => (
                                <Circle
                                    key={sequence + index}
                                    color={sequence}
                                />
                            ))}
                        </Box>
                    </Box>
                ))}
            </Box>
            <Typography>
                For more information regarding our LED sequences click
                <span className={styles.informationLink}>
                    <Link
                        href="https://support.tankutility.com/hc/en-us/articles/360033745553-Tank-Utility-Cellular-Monitor-LED-Light-Sequences"
                        target="__blank"
                    >
                        here
                    </Link>
                </span>
            </Typography>
        </FormSection>
    );
}

const possibleLedSequences = [
    {
        title: 'Successful connection',
        sequence: ['primary', 'primary', 'primary'],
    },
    {
        title: 'Attempting to send a reading',
        sequence: ['primary', 'primary', 'disabled'],
    },
    {
        title: 'Unsuccessful transmission',
        sequence: ['primary', 'error', 'disabled'],
    },
    {
        title: 'Batteries are dead and should be replaced',
        sequence: ['error', 'disabled', 'disabled'],
    },
];
